import { defineStore } from 'pinia'
import { type Ref } from 'vue'
import PaymentModal from '@/components/modals/PaymentModal.vue'
export type ThemeMode = 'light' | 'dark'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    forbidden: false,
    paymentModal: null as Ref<typeof PaymentModal> | null,
    mode:
      (localStorage.getItem('theme') as ThemeMode) ||
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'),
  }),

  getters: {
    isDark: (state): boolean => state.mode === 'dark',
  },

  actions: {
    toggle(): void {
      this.mode = this.isDark ? 'light' : 'dark'
      localStorage.setItem('theme', this.mode)
      this.apply()
    },
    setPaymentModalComponent(comp: typeof PaymentModal) {
      this.paymentModal = comp
    },
    apply(): void {
      if (this.isDark) {
        document.documentElement.classList.add('p-dark')
      } else {
        document.documentElement.classList.remove('p-dark')
      }
    },
  },
})
